export default __webpack_public_path__ + "static/cv-nicolasdirago-e296938a71e4243ab281ccf8744a7c10.pdf";